import React from "react";
import { Container } from "./styles";

const Separator = () => {
  return <Container></Container>;
};
export default Separator;
